/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_List_Export_FailedInputs */

const vi_lot_list_export_failed = /** @type {(inputs: Lot_List_Export_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất Excel thất bại, thử lại sau`)
};

/**

* @param {Lot_List_Export_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_list_export_failed = /** @type {((inputs?: Lot_List_Export_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_List_Export_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_list_export_failed(inputs)
});